var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7435",
    "data-name": "Rectangle 7435",
    width: 135,
    height: 40,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Playstore",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11653",
    "data-name": "Group 11653",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26890",
    "data-name": "Path 26890",
    d: "M130,40H5a5.015,5.015,0,0,1-5-5V5A5.015,5.015,0,0,1,5,0H130a5.015,5.015,0,0,1,5,5V35a5.015,5.015,0,0,1-5,5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26891",
    "data-name": "Path 26891",
    d: "M130,.8A4.2,4.2,0,0,1,134.2,5V35a4.2,4.2,0,0,1-4.2,4.2H5A4.2,4.2,0,0,1,.8,35V5A4.2,4.2,0,0,1,5,.8Zm0-.8H5A5.015,5.015,0,0,0,0,5V35a5.015,5.015,0,0,0,5,5H130a5.015,5.015,0,0,0,5-5V5a5.015,5.015,0,0,0-5-5",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26892",
    "data-name": "Path 26892",
    d: "M47.418,10.243a2.709,2.709,0,0,1-.745,2,2.893,2.893,0,0,1-2.2.888A3.089,3.089,0,0,1,41.352,10a3.089,3.089,0,0,1,3.117-3.134,3.336,3.336,0,0,1,1.248.234,2.491,2.491,0,0,1,.964.663l-.553.552a1.864,1.864,0,0,0-.717-.523,2.359,2.359,0,0,0-.942-.189,2.252,2.252,0,0,0-1.659.679A2.356,2.356,0,0,0,42.139,10a2.358,2.358,0,0,0,.671,1.718,2.255,2.255,0,0,0,1.659.678,2.226,2.226,0,0,0,1.491-.5,2,2,0,0,0,.687-1.382H44.469V9.79h2.907a2.572,2.572,0,0,1,.042.453",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26893",
    "data-name": "Path 26893",
    d: "M47.418,10.243a2.709,2.709,0,0,1-.745,2,2.893,2.893,0,0,1-2.2.888A3.089,3.089,0,0,1,41.352,10a3.089,3.089,0,0,1,3.117-3.134,3.336,3.336,0,0,1,1.248.234,2.491,2.491,0,0,1,.964.663l-.553.552a1.864,1.864,0,0,0-.717-.523,2.359,2.359,0,0,0-.942-.189,2.252,2.252,0,0,0-1.659.679A2.356,2.356,0,0,0,42.139,10a2.358,2.358,0,0,0,.671,1.718,2.255,2.255,0,0,0,1.659.678,2.226,2.226,0,0,0,1.491-.5,2,2,0,0,0,.687-1.382H44.469V9.79h2.907A2.572,2.572,0,0,1,47.418,10.243Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26894",
    "data-name": "Path 26894",
    d: "M52.028,7v.737H49.3v1.9h2.463v.72H49.3v1.9h2.732V13h-3.5V7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26895",
    "data-name": "Path 26895",
    d: "M52.028,7v.737H49.3v1.9h2.463v.72H49.3v1.9h2.732V13h-3.5V7Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26896",
    "data-name": "Path 26896",
    d: "M55.28,7.737V13h-.771V7.737H52.833V7h4.123v.737Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26897",
    "data-name": "Path 26897",
    d: "M55.28,7.737V13h-.771V7.737H52.833V7h4.123v.737Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7433",
    "data-name": "Rectangle 7433",
    width: 0.771,
    height: 6,
    transform: "translate(59.937 7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7434",
    "data-name": "Rectangle 7434",
    width: 0.771,
    height: 6,
    transform: "translate(59.937 7)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26898",
    "data-name": "Path 26898",
    d: "M64.128,7.737V13h-.771V7.737H61.681V7H65.8v.737Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26899",
    "data-name": "Path 26899",
    d: "M64.128,7.737V13h-.771V7.737H61.681V7H65.8v.737Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26900",
    "data-name": "Path 26900",
    d: "M74.493,10a3.042,3.042,0,0,1-.888,2.229,3.116,3.116,0,0,1-4.391,0A3.042,3.042,0,0,1,68.326,10a3.041,3.041,0,0,1,.888-2.229,3.106,3.106,0,0,1,4.391.008A3.032,3.032,0,0,1,74.493,10m-5.38,0a2.378,2.378,0,0,0,.653,1.718,2.206,2.206,0,0,0,1.643.678,2.18,2.18,0,0,0,1.635-.678A2.344,2.344,0,0,0,73.706,10a2.344,2.344,0,0,0-.662-1.718A2.18,2.18,0,0,0,71.409,7.6a2.206,2.206,0,0,0-1.643.678A2.38,2.38,0,0,0,69.113,10",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26901",
    "data-name": "Path 26901",
    d: "M74.493,10a3.042,3.042,0,0,1-.888,2.229,3.116,3.116,0,0,1-4.391,0A3.042,3.042,0,0,1,68.326,10a3.041,3.041,0,0,1,.888-2.229,3.106,3.106,0,0,1,4.391.008A3.032,3.032,0,0,1,74.493,10Zm-5.38,0a2.378,2.378,0,0,0,.653,1.718,2.206,2.206,0,0,0,1.643.678,2.18,2.18,0,0,0,1.635-.678A2.344,2.344,0,0,0,73.706,10a2.344,2.344,0,0,0-.662-1.718A2.18,2.18,0,0,0,71.409,7.6a2.206,2.206,0,0,0-1.643.678A2.38,2.38,0,0,0,69.113,10Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26902",
    "data-name": "Path 26902",
    d: "M76.345,13h-.771V7h.939l2.916,4.667h.033l-.033-1.156V7H80.2v6h-.8L76.345,8.106h-.033l.033,1.157Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26903",
    "data-name": "Path 26903",
    d: "M76.345,13h-.771V7h.939l2.916,4.667h.033l-.033-1.156V7H80.2v6h-.8L76.345,8.106h-.033l.033,1.157Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26904",
    "data-name": "Path 26904",
    d: "M68.136,21.752A4.253,4.253,0,1,0,72.4,26a4.192,4.192,0,0,0-4.269-4.253m0,6.83A2.584,2.584,0,1,1,70.536,26a2.46,2.46,0,0,1-2.4,2.577m-9.314-6.83A4.253,4.253,0,1,0,63.092,26a4.192,4.192,0,0,0-4.27-4.253m0,6.83A2.584,2.584,0,1,1,61.223,26a2.46,2.46,0,0,1-2.4,2.577M47.744,23.057v1.8h4.317a3.765,3.765,0,0,1-.982,2.271,4.42,4.42,0,0,1-3.335,1.321,4.8,4.8,0,0,1,0-9.6A4.6,4.6,0,0,1,51,20.14l1.273-1.272a6.3,6.3,0,0,0-4.527-1.821,6.606,6.606,0,1,0,0,13.211,6.04,6.04,0,0,0,4.607-1.853,5.962,5.962,0,0,0,1.563-4.221,5.829,5.829,0,0,0-.1-1.127Zm45.308,1.4a3.954,3.954,0,0,0-3.641-2.706A4.041,4.041,0,0,0,85.4,26a4.162,4.162,0,0,0,4.22,4.253,4.232,4.232,0,0,0,3.545-1.885l-1.45-.967a2.43,2.43,0,0,1-2.095,1.176,2.164,2.164,0,0,1-2.062-1.288l5.687-2.353Zm-5.8,1.418A2.333,2.333,0,0,1,89.475,23.4a1.646,1.646,0,0,1,1.579.9ZM82.628,30H84.5V17.5H82.628Zm-3.061-7.3H79.5a2.948,2.948,0,0,0-2.239-.95,4.257,4.257,0,0,0,0,8.506,2.9,2.9,0,0,0,2.239-.967h.064V29.9c0,1.628-.869,2.5-2.271,2.5a2.354,2.354,0,0,1-2.143-1.515l-1.627.677a4.053,4.053,0,0,0,3.77,2.513c2.191,0,4.044-1.289,4.044-4.43V22.009H79.567Zm-2.142,5.88a2.587,2.587,0,0,1,0-5.155A2.4,2.4,0,0,1,79.7,26.021a2.376,2.376,0,0,1-2.271,2.561M101.806,17.5H97.335V30H99.2V25.264h2.606a3.888,3.888,0,1,0,0-7.765m.048,6.025H99.2V19.239h2.654a2.143,2.143,0,1,1,0,4.285m11.532-1.8a3.505,3.505,0,0,0-3.33,1.913l1.657.692a1.768,1.768,0,0,1,1.705-.917,1.8,1.8,0,0,1,1.962,1.609v.128a4.128,4.128,0,0,0-1.946-.482c-1.785,0-3.6.981-3.6,2.814a2.889,2.889,0,0,0,3.1,2.751,2.633,2.633,0,0,0,2.381-1.223h.064v.965h1.8V25.186c0-2.219-1.656-3.457-3.795-3.457m-.225,6.851c-.612,0-1.464-.306-1.464-1.062,0-.965,1.061-1.334,1.978-1.334a3.319,3.319,0,0,1,1.7.418,2.262,2.262,0,0,1-2.219,1.978M123.743,22l-2.139,5.42h-.064L119.32,22h-2.01l3.329,7.575-1.9,4.214h1.946L125.818,22Zm-16.807,8H108.8V17.5h-1.866Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26905",
    "data-name": "Path 26905",
    d: "M20.717,19.424,10.07,30.724l0,.007a2.878,2.878,0,0,0,4.236,1.734l.034-.02L26.326,25.53Z",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26906",
    "data-name": "Path 26906",
    d: "M31.488,17.5l-.01-.007-5.174-3-5.829,5.187,5.85,5.848,5.146-2.969a2.878,2.878,0,0,0,.017-5.06",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26907",
    "data-name": "Path 26907",
    d: "M10.07,9.277a2.823,2.823,0,0,0-.1.74V29.985a2.769,2.769,0,0,0,.1.739L21.083,19.713Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26908",
    "data-name": "Path 26908",
    d: "M20.8,20l5.51-5.509-11.97-6.94a2.881,2.881,0,0,0-4.265,1.722v0Z",
    fill: "#34a853"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/Playstore.2be112aea00d2b3436eb14d794a462ed.svg";
export { ForwardRef as ReactComponent };